import BottomNavbar from "Components/Nav/BottomNavbar";
import Loader from "Components/Scene/Loader";
import Tutorial from "Components/Scene/Tutorial";
import { Suspense, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { RouterMobile } from "Router/RouterMobile";
import TopNavbar from "./Components/Nav/TopNavbar";
import { IsMutedProvider } from "./context/InteractiveContext";
import { Router } from "./Router/Router";

function App() {
  const [returnLink, setReturnLink] = useState(false);
  const [showMenuToggler, setShowMenuToggler] = useState(false);
  const [isBackgroundMusic, setIsBackgroundMusic] = useState(false);
  const [pageTitle, setPageTitle] = useState();
  const [tutorialPage, setTutorialPage] = useState();

  const [isMuted, setIsMuted] = useState(true);

  function toggleMuted(boolean) {
    switch (boolean) {
      case true:
        setIsMuted(true);
        break;
      case false:
        setIsMuted(false);
        break;
      default:
        setIsMuted((isMuted) => !isMuted);
        break;
    }
  }

  const contextVal = {
    isMuted,
    toggleMuted,
  };
  return (
    <IsMutedProvider value={contextVal}>
      <BrowserRouter>
        <TopNavbar
          pageTitle={pageTitle}
          showMenuToggler={showMenuToggler}
          isBackgroundMusic={isBackgroundMusic}
          setTutorialPage={setTutorialPage}
          tutorialPage={tutorialPage}
          returnLink={returnLink}
        />
        <Suspense fallback={<Loader />}>
          {window.innerWidth >= 728 && (
            <Router
              setPageTitle={setPageTitle}
              setShowMenuToggler={setShowMenuToggler}
              setIsBackgroundMusic={setIsBackgroundMusic}
              setReturnLink={setReturnLink}
              returnLink={returnLink}
              tutorialPage={tutorialPage}
              setTutorialPage={setTutorialPage}
            />
          )}
          {window.innerWidth < 728 && (
            <RouterMobile
              setPageTitle={setPageTitle}
              setShowMenuToggler={setShowMenuToggler}
              setIsBackgroundMusic={setIsBackgroundMusic}
              setReturnLink={setReturnLink}
            />
          )}
        </Suspense>
        <Tutorial
          tutorialPage={tutorialPage}
          setTutorialPage={setTutorialPage}
        />
        <BottomNavbar />
      </BrowserRouter>
    </IsMutedProvider>
  );
}

export default App;
